export const PAYMENT_FREQUENCY = {
  TOTAL: '1',
  DIRECT_DEBIT: '12'
};
